<template>
  <section class="contain">
    <!-- 顶部安全区 -->
    <div class="van-safe-area-top"></div>
    <div class="prism-player" id="player-con">
      <!-- <marquee class="marquee" direction="right" scrollamount="5">{{liveData.video_statement}}</marquee> -->
      <div class="views">
        <van-icon
          name="friends-o"
          class="views-icon"
          size="17px"
          color="#fff"
        />
        <span class="views-num"
          >{{ (liveData.views / 10000).toFixed(2) }}万</span
        >
      </div>
    </div>
    <van-swipe class="swipe" :autoplay="3000" :show-indicators="false">
      <van-swipe-item
        v-for="(item, index) in liveData.adverts"
        :key="index"
        @click="jumpUrl(item.url)"
      >
        <img class="item-img" :src="item.image" />
      </van-swipe-item>
    </van-swipe>
    <div class="introduce">
      <div class="introduce-notify" v-show="notifyShow">
        <div class="notify-left">
          <van-icon name="volume-o" color="#1684FC" size="20" class="volume" />
          <marquee class="text" direction="left" scrollamount="5">
            {{ liveData.notice }}
          </marquee>
        </div>
        <van-icon
          name="cross"
          color="#6D7077"
          size="16"
          @click="notifyShow = false"
        />
      </div>
      <van-tabs
        :active="activeName"
        color="#1684FC"
        :before-change="onClickTab"
        style="z-index: 100"
      >
        <van-tab
          title="直播简介"
          name="content"
          style="background: #fff; padding: 10px 20px"
        >
          <div
            style="overflow: scroll; height: 340px"
            v-html="liveData.content"
          ></div>
        </van-tab>
        <van-tab title="互动评论" name="list" v-if="id != 4 && id != 10">
          <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
          <van-list
            :loading="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            class="van_list"
          >
            <div class="chat-list">
              <div
                class="chat-item"
                v-for="item in chatList"
                :key="item"
                :title="item"
              >
                <div class="bg_box">
                  <van-image
                    width="26"
                    height="26"
                    fit="cover"
                    round
                    :src="item.avatar"
                    class="chat-img"
                  />
                  <div class="chat-msg">
                    <p class="chat-username">
                      <span style="color: #666">{{ item.username }}：</span>
                      {{ item.content }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
          <!-- </van-pull-refresh> -->
          <van-search
            v-model="value"
            show-action
            placeholder="我来说两句"
            @search="onSearch"
            left-icon="chat-o"
            class="bottom-search"
          >
            <template #action>
              <van-button type="primary" @click="onClickButton" class="send-btn"
                >发送</van-button
              >
              <div class="like_btn" @click="handleLike">
                <van-icon
                  name="like"
                  size="30"
                  color="#ff1314"
                  class="like_btn_icon"
                />
                <span>{{ liveData.like }}</span>
              </div>
            </template>
          </van-search>
        </van-tab>
        <!-- <van-tab
          title="直播简介"
          name="content"
          style="background: #fff; padding: 10px 20px"
        >
          <div
            style="overflow: scroll; height: 340px"
            v-html="liveData.content"
          ></div>
        </van-tab> -->
        <!-- <van-tab title="直播抽奖" name="3"></van-tab> -->
        <van-tab title="更多直播" name="4"></van-tab>
      </van-tabs>
    </div>
    <wx-open-launch-app
      v-if="isWechat"
      id="launch-btn"
      appid="wxc9da92efaf026389"
      :extinfo="extInfo"
      style="width: 100vw; height: 16vw; left: 0; position: absolute; top: 0"
      @launch="handleLaunch"
      @error="handleError"
    >
      <div v-is="'script'" type="text/wxtag-template">
        <button
          style="
            border-width: 0;
            width: 100%;
            height: 50px;
            background: rgba(248, 1, 1, 0);
          "
        ></button>
      </div>
    </wx-open-launch-app>
    <audio v-if="id == 1" loop id="audio" ref="audio">
      <source :src="require('@/assets/bgmusic.mp3')" type="audio/mpeg" />
    </audio>
    <van-image
      v-if="id == 1"
      width="10vw"
      height="20vw"
      fit="cover"
      class="banner"
      :src="require('@/assets/img/banner.png')"
    />
    <van-image
      v-if="id != 1"
      width="5vw"
      height="5vw"
      fit="cover"
      class="logo"
      :src="require('@/assets/img/zsplus.jpg')"
    />
    <!-- 底部安全区 -->
    <div class="van-safe-area-bottom"></div>
  </section>
</template>

<script>
import {
  Image as VanImage,
  Grid,
  GridItem,
  Swipe,
  SwipeItem,
  Tab,
  Tabs,
  Icon,
  List,
  PullRefresh,
  Toast,
  Search,
  Button,
} from "vant";
import { onMounted, ref, getCurrentInstance } from "vue";
import useShare from "@/composiables/useShare";
import { useStore } from "vuex";
import Api from "../api";
import { useRouter, useRoute } from "vue-router";
export default {
  components: {
    [VanImage.name]: VanImage,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Icon.name]: Icon,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Toast.name]: Toast,
    [Search.name]: Search,
    [Button.name]: Button,
  },
  setup() {
    const store = useStore();
    const activeName = ref("content");
    const notifyShow = ref(true);
    const route = useRoute();
    const id = ref(route.query.id);
    let activity_id = route.query.id;
    if (activity_id) {
      sessionStorage.setItem("activity_id", route.query.id);
    } else {
      activity_id = sessionStorage.getItem("activity_id");
    }
    const jumpUrl = (url) => {
      if (url) {
        window.open(url, "_blank");
      }
    };

    const onClickTab = (index) => {
      console.log(index);
      if (index == 3) {
        jumpUrl("https://zsrbactivity.zsnews.cn/vue/drawform/#/22");
        return false;
      }
      if (index == 4) {
        // router.push({ path: "/liveList" });
        jumpUrl("http://zsrbactivity.zsnews.cn/vue/slow_live/#/liveList");
        return false;
      }
      // 返回 Promise 来执行异步逻辑
      return new Promise((resolve) => {
        // 在 resolve 函数中返回 true 或 false
        resolve(index !== 3);
      });
    };
    const isWechat = navigator.userAgent.toLowerCase().indexOf("zsrbapp") < 0;

    const extInfo = ref("");
    let apkLink = "";

    const list = ref([]);
    const chatList = ref([]);
    const page = ref(1);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);

    const onLoad = () => {
      getChatlist();
    };

    let liveData = ref({});
    const player = () => {
      console.log("执行顺序", 2);
      new Aliplayer(
        {
          id: "player-con",
          source: liveData.value.source,
          width: "100vw",
          height: "56vw",
          videoHeight: "auto",
          autoplay: true,
          isLive: true,
          rePlay: false,
          playsinline: true,
          preload: true,
          controlBarVisibility: "click",
          useH5Prism: true,
          cover: liveData.value.image,
        },
        function (player) {
          player.play();
        }
      );
    };
    const onRefresh = () => {
      // 清空列表数据
      finished.value = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      loading.value = true;
      onLoad();
    };
    const handleLike = () => {
      let params = { activity_id };
      Api.getLike(params).then((res) => {
        console.log(res);
        liveData.value.like++;
        // Toast(res.msg);
      });
    };

    const getLiveData = async () => {
      let params = { activity_id };
      Api.getLiveDetail(params).then((res) => {
        console.log(res.data);
        if (!res.data.notice) notifyShow.value = false;
        liveData.value = res.data;
        document.title = res.data.title;
        useShare(
          res.data.title,
          "https://zsrbactivity.zsnews.cn" + require("@/assets/img/zsplus.png"),
          "",
          window.location.href
        );
        player();
      });
    };

    const getChatlist = async (_page) => {
      if (activity_id == 4) {
        return;
      }
      let params = {
        activity_id,
        page: _page ? _page : page.value,
      };
      Api.getLiveChatlist(params)
        .then((res) => {
          // console.log(res.data);
          if (res.data.length > 0) {
            page.value++;
            chatList.value = chatList.value.concat(res.data);
          } else {
            finished.value = true;
          }

          loading.value = false;
          refreshing.value = false;
        })
        .catch(() => {
          loading.value = false;
        });
    };

    const value = ref("");
    const onSearch = () => {
      handleLiveSubmit();
    };
    const onClickButton = () => {
      handleLiveSubmit();
    };

    const handleLiveSubmit = async () => {
      if (!value.value) {
        Toast("内容不能为空");
        return;
      }
      let params = { activity_id, content: value.value };
      await Api.LiveSubmit(params).then((res) => {
        value.value = "";
        Toast(res.msg);
      });
    };
    const proxy = getCurrentInstance();

    onMounted(() => {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          proxy.refs.audio.play();
        },
        false
      );
      document.addEventListener("touchstart", function () {
        proxy.refs.audio.play();
      });
      getLiveData();
      console.log("liveData", liveData);
      setInterval(() => {
        getChatlist();
      }, 2000);

      store.dispatch("getJump").then((res) => {
        const userAgentString = navigator.userAgent.toLowerCase();
        if (
          userAgentString.indexOf("iphone") > 0 ||
          userAgentString.indexOf("ipad") > 0
        ) {
          extInfo.value = res.iosExinfo ? res.iosExinfo : "";
        } else {
          extInfo.value = res.androidExinfo ? res.androidExinfo : "";
        }
        apkLink = res.apkLink ? res.apkLink : "";
      });
    });

    const handleLaunch = (e) => {
      console.log("handleLaunch", e);
    };

    const handleError = (e) => {
      console.log("handleError", e);
      window.open(apkLink, "_blank");
    };

    return {
      id,
      player,
      jumpUrl,
      extInfo,
      isWechat,
      handleLaunch,
      handleError,
      activeName,
      notifyShow,
      list,
      onLoad,
      loading,
      finished,
      onRefresh,
      refreshing,
      liveData,
      chatList,
      value,
      onSearch,
      onClickButton,
      handleLiveSubmit,
      onClickTab,
      handleLike,
    };
  },
};
</script>

<style lang="scss" scoped>
.contain {
  width: 100%;
  overflow: hidden;
  background: #f8f8f8;
  height: 100vh;
}

.prism-player {
  width: 100vw;
  height: 56vw;
  background-color: #ffffff;
}

.swipe {
  margin-top: 4px;

  .item-img {
    width: 100%;
  }
}

.marquee {
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 14px;
  color: #fff;
  width: 290px;
  z-index: 100;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.2));
}

.views {
  position: absolute;
  bottom: 10px;
  left: 16px;
  font-size: 14px;
  color: #fff;
  z-index: 100;
  height: 24px;
  display: flex;
  align-items: center;
  border-radius: 12px;
  background-color: rgba(98, 98, 98, 0.5);
  padding: 0 5px;
}

.introduce {
  width: 100%;

  .introduce-notify {
    background: #f5faff;
    color: #101010;
    font-size: 12px;
    height: 36px;
    // line-height: 36px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;

    .notify-left {
      display: flex;
      align-items: center;

      .text {
        width: 80vw;
        font-size: 14px;
      }

      .volume {
        margin-right: 5px;
      }
    }
  }
}

:deep(.van-list__finished-text) {
  opacity: 0;
}

.van_list {
  overflow-y: scroll;
  height: 330px;
}

.chat-list {
  // height: 340px;
  .chat-item {
    display: flex;
    align-items: center;
    padding: 2px 16px 0;
    margin-top: 5px;

    .bg_box {
      background: rgba(0, 0, 0, 0.05);
      border-radius: 8px;
      display: flex;
      padding: 6px 10px 2px 5px;
    }

    .chat-img {
      margin-right: 8px;
    }

    .chat-msg {
      box-sizing: border-box;
      max-width: 85%;

      .chat-username {
        margin: 0;
        font-size: 14px;
        line-height: 22px;
      }
    }
  }
}

.bottom-search {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 100;
  height: 78px;
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 0;
  background: #fff;

  // box-sizing: border-box;
  :deep(.van-search__content) {
    height: 36px;
    border-radius: 16px;
  }

  :deep(.van-search__action) {
    height: 36px;
    display: flex;
    align-items: center;
  }

  :deep(.van-search__field) {
    display: flex;
    align-items: center;
  }

  .send-btn {
    height: 36px;
    border-radius: 8px;
    padding: 0 20px;
    font-size: 14px;
  }
}

.like_btn {
  margin-left: 10px;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #999;
  font-weight: 500;

  .like_btn_icon {
    margin-right: 4px;
  }
}

.banner {
  position: fixed;
  top: 10vw;
  right: 3vw;
  z-index: 100;
}

.logo {
  position: fixed;
  top: 3vw;
  right: 3vw;
  z-index: 100;
}
</style>
